import { useState } from "react";
import { History, ChevronDown } from "lucide-react";

const LABELS = {
  iscritto: "si è iscritto",
  ritirato: "si è ritirato",
  inserito: "inserito da",
  tolto: "tolto da",
  sostituito: "sostituito da",
  mezzo: "mezzo cambiato",
};
const COLORS = { tolto: "text-destructive", ritirato: "text-destructive", sostituito: "text-amber-600", mezzo: "text-sky-700" };

function describe(h) {
  if (h.action === "mezzo") return <>Mezzo: <b>{h.replaced}</b> → <b>{h.name}</b> · da {h.by}</>;
  if (h.action === "appello") return <>Appello inviato a <b>{h.name}</b> · da {h.by}</>;
  if (h.action === "sostituito") return <><b>{h.replaced}</b> → <b>{h.name}</b> ({h.role}) · da {h.by}</>;
  if (h.action === "iscritto" || h.action === "ritirato") return <><b>{h.name}</b> {LABELS[h.action]} ({h.role})</>;
  return <><b>{h.name}</b> ({h.role}) {LABELS[h.action]} {h.by}</>;
}

export function ServiceHistory({ history }) {
  const [open, setOpen] = useState(false);
  if (!history || history.length === 0) return null;
  const items = [...history].reverse();
  return (
    <div className="rounded-lg border border-border" data-testid="service-history">
      <button type="button" data-testid="service-history-toggle" onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between px-3 py-2 text-sm font-semibold hover:bg-muted transition-colors">
        <span className="flex items-center gap-1.5"><History className="h-4 w-4 text-[#D32F2F]" /> Storico modifiche ({history.length})</span>
        <ChevronDown className={`h-4 w-4 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <ul className="px-3 pb-3 space-y-1.5 max-h-64 overflow-y-auto">
          {items.map((h, i) => (
            <li key={i} data-testid={`history-item-${i}`} className="text-xs flex gap-2">
              <span className="text-muted-foreground font-mono shrink-0">
                {new Date(h.at).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" })}
              </span>
              <span className={COLORS[h.action] || ""}>{describe(h)}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
